// Included in each downloadable script. Configuration contains only the public pixel token.
function courierDelivery(config, allowed) {
  return function send(payload) {
    const body = JSON.stringify({...payload, token: config.token});
    // Browsers limit total keepalive bodies; do not silently truncate a form submission.
    if (new TextEncoder().encode(body).length > 48000) {
      console.warn('Courier: observation exceeds browser delivery limit');
      return;
    }
    function attempt(number) {
      if (!allowed()) return;
      fetch(config.endpoint, {method: 'POST', mode: 'cors', credentials: 'omit',
        headers: {'Content-Type': 'text/plain'}, body, keepalive: true})
        .then(response => { if (!response.ok) throw new Error('intake unavailable'); })
        .catch(() => {
          if (number < 5) setTimeout(() => attempt(number + 1), 1000 * 2 ** number);
          else console.warn('Courier: observation could not be delivered');
        });
    }
    attempt(0);
  };
}

// Functional submissions only: no page tracking, no private credentials. Pending
// requests survive reloads in this tab and are removed as soon as SQS accepts them.
function courierSignupDelivery(config) {
  const storageKey = 'courier.pending-signups.v1';
  const maxAge = 24 * 60 * 60 * 1000;
  let queue = [], busy = false, timer;
  try {
    const stored = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) queue = stored.filter(row => row && typeof row.body === 'string' &&
      row.body.length < 16000 && Number.isFinite(row.created) && row.created > Date.now() - maxAge &&
      row.created <= Date.now() && Number.isFinite(row.next)).slice(0, 30);
  } catch (_) { /* Storage may be blocked; keep in-memory delivery available. */ }
  function persist() {
    try {
      if (queue.length) sessionStorage.setItem(storageKey, JSON.stringify(queue));
      else sessionStorage.removeItem(storageKey);
    } catch (_) { /* Network delivery continues when browser storage is unavailable. */ }
  }
  function notify(state) {
    window.dispatchEvent(new CustomEvent('courier:signup-delivery', {detail: {state, pending: queue.length}}));
  }
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(flush, Math.max(0, delay));
  }
  async function flush() {
    if (busy) return;
    const expired = queue.some(row => row.created <= Date.now() - maxAge);
    queue = queue.filter(row => row.created > Date.now() - maxAge);
    persist();
    if (expired) notify('expired');
    const row = queue.find(row => row.next <= Date.now());
    if (!row) {
      if (queue.length) schedule(Math.min(...queue.map(row => row.next)) - Date.now());
      return;
    }
    busy = true;
    let retryAfter = 0;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      // The endpoint comes from the current installation, never browser storage.
      const response = await fetch(config.endpoint, {method: 'POST', mode: 'cors', credentials: 'omit',
        headers: {'Content-Type': 'text/plain'}, body: row.body, keepalive: true, signal: controller.signal});
      if (!response.ok) {
        const value = response.headers?.get('Retry-After');
        retryAfter = /^\d+$/.test(value || '') ? Number(value) * 1000 : Math.max(0, Date.parse(value) - Date.now()) || 0;
        throw new Error('intake unavailable');
      }
      queue = queue.filter(item => item !== row);
      notify('accepted'); // Durable intake accepted; does not imply email sending.
    } catch (_) {
      row.attempt = Math.min((row.attempt || 0) + 1, 8);
      row.next = Date.now() + Math.min(maxAge, Math.max(retryAfter, Math.min(60000, 1000 * 2 ** (row.attempt - 1))));
      notify('retrying');
    } finally {
      clearTimeout(timeout);
      busy = false;
      persist();
      if (queue.length) schedule(Math.min(...queue.map(item => item.next)) - Date.now());
    }
  }
  window.addEventListener('online', () => { if (queue.length) schedule(0); });
  persist();
  if (queue.length) schedule(0);
  return payload => {
    const body = JSON.stringify({...payload, token: config.token});
    if (new TextEncoder().encode(body).length > 16000 || queue.length >= 30) {
      notify('capacity');
      console.warn('Courier: signup mirror queue is full; Klaviyo remains the recovery source');
      return false;
    }
    queue.push({body, created: Date.now(), next: Date.now(), attempt: 0});
    persist();
    flush();
    return true;
  };
}

// Install as a theme asset loaded before Klaviyo/PageFly. Existing form behavior stays intact.
// https://developers.klaviyo.com/en/docs/track_klaviyo_form_activity_using_javascript
(() => {
  if (window.__courierFormsInstalled) return;
  window.__courierFormsInstalled = true;
  const config = {"endpoint": "https://ag.production.realm.sensibo.com/courier/pixel", "token": "cmQ7mofD44Cgot456GlIJ9LRUbRUkmM8", "forms": {"VUXG4p": {"version": "16394965", "company_id": "PWWS4a", "fields": [{"key": "Name", "type": "TEXT_INPUT", "required": false, "label": "Name"}, {"key": "$email", "type": "EMAIL", "required": true, "label": "Email"}]}, "Xqv9xG": {"version": "25012470", "company_id": "PWWS4a", "fields": [{"key": "$email", "type": "EMAIL", "required": true, "label": "Email"}]}, "TYiLX6": {"version": "22064558", "company_id": "PWWS4a", "fields": [{"key": "$email", "type": "EMAIL", "required": true, "label": "EMAIL ADDRESS"}]}, "RMmhtH": {"version": "14910044", "company_id": "PWWS4a", "fields": [{"key": "$first_name", "type": "TEXT_INPUT", "required": false, "label": "First Name"}, {"key": "$last_name", "type": "TEXT_INPUT", "required": false, "label": "Last Name"}, {"key": "$email", "type": "EMAIL", "required": true, "label": "Email"}, {"key": "$phone_number", "type": "PHONE_NUMBER", "required": false, "label": "Phone Number"}, {"key": "$country", "type": "TEXT_INPUT", "required": false, "label": "Country"}, {"key": "number_of_rooms", "type": "TEXT_INPUT", "required": false, "label": "How many rooms do you manage?"}]}, "RfB2g6": {"version": "12602378", "company_id": "PWWS4a", "fields": [{"key": "$email", "type": "EMAIL", "required": true, "label": "Email"}]}, "pagefly-ai-assistant-waitlist": {"version": "2026-09-14", "company_id": "", "fields": [{"key": "$email", "type": "EMAIL", "required": true, "label": "Email"}]}}};
  const signup = courierSignupDelivery(config);
  const seen = new Set();
  function captureSignup(formId, submitted, companyId, trigger) {
    const form = config.forms?.[formId];
    if (!form || form.company_id !== companyId || !submitted || typeof submitted !== 'object') return;
    const fields = {};
    for (const field of form.fields) {
      const value = submitted[field.key] ?? submitted[field.key.replace(/^\$/, '')];
      if (value != null && typeof value === 'string') fields[field.key] = value.trim();
    }
    if (!fields.$email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.$email)) return;
    const fingerprint = JSON.stringify([formId, fields]);
    if (seen.has(fingerprint)) return;
    if (signup({event: 'form_subscription', id: crypto.randomUUID(), form_id: formId,
      definition_version: form.version, company_id: companyId, trigger, fields,
      timestamp: new Date().toISOString()})) seen.add(fingerprint);
  }
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true;
  };
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {});
  }
  const send = courierDelivery(config, allowed);
  const events = {open: 'form_viewed', embedOpen: 'form_viewed', submit: 'form_submitted',
    stepSubmit: 'form_step_submitted', close: 'form_closed', redirectedToUrl: 'form_redirected'};
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail;
    // A deliberate signup is functional intake, independent of analytics cookies.
    // Only audited subscription forms are eligible; views/closes grant no consent.
    if (detail && ['submit', 'stepSubmit'].includes(detail.type)) {
      captureSignup(detail.formId, detail.metaData, detail.companyId, 'klaviyo_submit');
    }
    if (!detail || !events[detail.type] || !detail.formId || !allowed()) return;
    send({event: events[detail.type], id: crypto.randomUUID(), timestamp: new Date().toISOString(),
      data: {form_id: detail.formId, provider_event: detail.type, company_id: detail.companyId,
        fields: detail.metaData || {}}, context: {page: location.href}});
  });
  // Explicit integration point for custom PageFly or future internal forms. Call only
  // after their own validation; do not intercept every form or capture passwords.
  document.addEventListener('click', event => {
    const button = event.target?.closest?.('.__pf_7mXUSvV- .join-button');
    if (!button) return;
    const input = button.closest('.__pf_7mXUSvV-')?.querySelector('input#email[type=email]');
    if (!input?.value || !input.checkValidity()) return;
    captureSignup('pagefly-ai-assistant-waitlist', {email: input.value}, '', 'validated_waitlist_click');
    window.CourierForms.observeSubmission('pagefly-ai-assistant-waitlist',
      {email: input.value, 'ai-assistant-waitlist': new Date().toISOString()});
  });
  window.CourierForms = Object.freeze({observeSubmission(formId, fields, submissionId) {
    if (!allowed() || typeof formId !== 'string' || !fields || typeof fields !== 'object' || Array.isArray(fields)) return;
    send({event: 'custom_form_submitted', id: submissionId || crypto.randomUUID(),
      timestamp: new Date().toISOString(), data: {form_id: formId, fields}, context: {page: location.href}});
  }});
})();
